import script from "./AppMixin.vue?vue&type=script&lang=js"
export * from "./AppMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__